export default __webpack_public_path__ + "static/media/icon-more-toggle.0977d862.svg";